(function () {
  if (window.__portraitWizardInit) return;
  window.__portraitWizardInit = true;

  var current = 1;

  function getSteps() {
    return document.querySelectorAll('[data-portrait-step]');
  }

  function getProgressDots() {
    return document.querySelectorAll('[data-progress-for]');
  }

  function show(n) {
    getSteps().forEach(function (el) {
      el.hidden = Number(el.dataset.portraitStep) !== n;
    });
    getProgressDots().forEach(function (dot) {
      var forStep = Number(dot.dataset.progressFor);
      dot.classList.toggle('is-active', forStep === n);
      dot.classList.toggle('is-done', forStep < n);
    });
    current = n;
    if (n === 4) populateReview();
  }

  function validateStep(n) {
    var step = document.querySelector('[data-portrait-step="' + n + '"]');
    if (!step) return true;
    var fields = step.querySelectorAll('[required]');
    for (var i = 0; i < fields.length; i++) {
      if (!fields[i].checkValidity()) {
        fields[i].reportValidity();
        return false;
      }
    }
    return true;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function populateReview() {
    var summary = document.querySelector('[data-portrait-review-summary]');
    if (!summary) return;

    var cards = [];

    document.querySelectorAll('variant-selects legend').forEach(function (legend) {
      var selected = legend.querySelector('[data-selected-value]');
      if (!selected) return;
      var label = legend.textContent.split(':')[0].trim();
      var stepEl = legend.closest('[data-portrait-step]');
      cards.push({ label: label, value: selected.textContent.trim(), step: stepEl ? stepEl.dataset.portraitStep : '1' });
    });

    document.querySelectorAll('.pet-photo-upload__pet').forEach(function (pet) {
      var nameInput = pet.querySelector('input[type="text"]');
      var fileInput = pet.querySelector('input[type="file"]');
      var previewImg = pet.querySelector('[data-pet-photo-preview]');
      var petLabel = pet.querySelector('.pet-photo-upload__pet-heading');
      var namePrefix = petLabel ? petLabel.textContent.trim() : "Pet's";
      var hasPhoto = !!(fileInput && fileInput.files.length);
      cards.push({ label: namePrefix + ' name', value: (nameInput && nameInput.value) || '—', step: '3' });
      cards.push({
        label: namePrefix + ' photo',
        value: hasPhoto ? fileInput.files[0].name : 'No file selected',
        step: '3',
        imageUrl: hasPhoto && previewImg && previewImg.src ? previewImg.src : null,
      });
    });

    var addonCheckbox = document.querySelector('[data-artwork-preview-checkbox]');
    if (addonCheckbox) {
      cards.push({
        label: 'Artwork Preview',
        value: addonCheckbox.checked ? 'Added ($9.99)' : 'Not added',
        step: '3',
      });
    }

    summary.innerHTML = '';
    cards.forEach(function (card) {
      var el = document.createElement('div');
      el.className = 'portrait-review__card';
      var thumb = card.imageUrl ? '<img class="portrait-review__thumb" src="' + card.imageUrl + '" alt="">' : '';
      el.innerHTML =
        thumb +
        '<dl><dt>' + escapeHtml(card.label) + '</dt><dd>' + escapeHtml(card.value) + '</dd></dl>' +
        '<button type="button" class="portrait-review__edit" data-portrait-edit="' + card.step + '">Edit</button>';
      summary.appendChild(el);
    });

    var priceRoot = document.querySelector('.price');
    var priceValueEl =
      priceRoot &&
      (priceRoot.querySelector('.price__sale .price-item--sale') ||
        priceRoot.querySelector('.price__regular .price-item--regular'));
    var priceTarget = document.querySelector('[data-portrait-review-price]');
    var priceNoteTarget = document.querySelector('[data-portrait-review-price-note]');
    var addonIncluded = !!(addonCheckbox && addonCheckbox.checked);

    if (priceValueEl && priceTarget) {
      var priceText = priceValueEl.textContent.replace(/\s+/g, ' ').trim();
      var addonPrice = parseFloat((addonCheckbox && addonCheckbox.dataset.artworkPreviewPrice) || '9.99');

      if (addonIncluded) {
        var match = priceText.match(/([\d,]+\.\d{2})/);
        if (match) {
          var base = parseFloat(match[1].replace(/,/g, ''));
          priceText = '$' + (base + addonPrice).toFixed(2);
        }
      }

      priceTarget.textContent = priceText;

      if (priceNoteTarget) {
        priceNoteTarget.hidden = !addonIncluded;
        if (addonIncluded) {
          priceNoteTarget.textContent = 'Includes Artwork Preview ($' + addonPrice.toFixed(2) + ')';
        }
      }
    }
  }

  document.addEventListener('click', function (e) {
    var next = e.target.closest('[data-portrait-next]');
    if (next) {
      if (!validateStep(current)) return;
      show(Math.min(current + 1, 4));
      return;
    }
    var back = e.target.closest('[data-portrait-back]');
    if (back) {
      show(Math.max(current - 1, 1));
      return;
    }
    var edit = e.target.closest('[data-portrait-edit]');
    if (edit) {
      show(Number(edit.dataset.portraitEdit));
      return;
    }
    var checkoutBtn = e.target.closest('[data-portrait-checkout]');
    if (checkoutBtn) {
      var returnTo = document.querySelector('[data-portrait-return-to]');
      if (returnTo) returnTo.value = '/checkout';
    }
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-pet-photo-input]')) return;
    var wrapper = e.target.closest('.pet-photo-upload__file');
    var label = wrapper && wrapper.querySelector('[data-pet-photo-filename]');
    var preview = wrapper && wrapper.querySelector('[data-pet-photo-preview]');
    if (!label) return;
    var hasFile = e.target.files.length > 0;
    label.textContent = hasFile ? e.target.files[0].name : 'Click to upload a photo';
    wrapper.classList.toggle('has-file', hasFile);

    if (preview) {
      if (preview.dataset.objectUrl) {
        URL.revokeObjectURL(preview.dataset.objectUrl);
        delete preview.dataset.objectUrl;
      }
      if (hasFile) {
        var url = URL.createObjectURL(e.target.files[0]);
        preview.src = url;
        preview.dataset.objectUrl = url;
        preview.hidden = false;
      } else {
        preview.removeAttribute('src');
        preview.hidden = true;
      }
    }
  });

  function init() {
    if (!getSteps().length) return;

    // Dawn re-fetches the section and swaps out the entire <variant-selects>
    // subtree on every option change (product-info.js's updateOptionValues).
    // The fresh HTML always starts from its server-rendered default (step 1
    // open, step 2 hidden), so for one synchronous moment mid-swap the page
    // loses however much height step 2/3/4 had — and the browser clamps
    // window.scrollY to fit the shorter page right then, before our own
    // show(current) below puts the real step back and the page regains its
    // height. The clamp doesn't reverse itself once the height comes back,
    // which is what read as the page jumping toward the top on mobile.
    // Record the scroll position the instant the shopper picks a value
    // (before Dawn's fetch/swap even starts) and force it back after we've
    // restored the correct step, instead of trusting the browser to keep it.
    var savedScrollY = null;

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function () {
        savedScrollY = window.scrollY;
      });

      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        show(current);
        if (savedScrollY === null) return;
        var y = savedScrollY;
        window.scrollTo({ top: y, left: window.scrollX, behavior: 'instant' });
        // product-info.js re-focuses the last-clicked option value slightly
        // after this fires (once the fetch's outer .then() resolves), which
        // can still trigger a focus-scroll on browsers that don't fully
        // honour focus({ preventScroll: true }). Re-apply once more next
        // frame, after that focus call has had a chance to run.
        requestAnimationFrame(function () {
          window.scrollTo({ top: y, left: window.scrollX, behavior: 'instant' });
        });
        savedScrollY = null;
      });
    }

    show(1);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
